module.exports = __webpack_public_path__ + "media/efeito.c42207a2.wav";